import { LoginModalActionType } from "../actiontype/login-modal.actiontype";

export const setLoginFormValidated = validForm => dispatch => {
    dispatch(setInvalidAirtelNumber(false));
    dispatch(setUserId(validForm.userId));
    dispatch(loginFormValidated(validForm));
};

function loginFormValidated(validForm) { return { type: LoginModalActionType.LOGIN_FORM_VALIDATED, payload: validForm.valid } }
function setInvalidAirtelNumber(invalid) { return { type: LoginModalActionType.INVALID_AIRTEL_NUMBER, payload: invalid } };
function setUserId(value) { return { type: LoginModalActionType.USER_ID, payload: value } };
export function otpSentFailed(otpSentFailed) { return { type: LoginModalActionType.OTP_SENT_FAILED, payload: otpSentFailed } };